<template>
    <v-app class="portrait">
        <v-row justify="center">
            <v-col cols="12" sm="12" md="12" lg="12" style="background-color:#f5f5f5" class="pa-1">
                <v-card>
                    <v-toolbar color="blue" dark>
                        <v-toolbar-title>
                            <v-chip @click="dTable.search =''" class="ma-1" color="indigo" text-color="white">
                                <v-avatar left>{{computedPersonals.length}}</v-avatar> TOTAL
                            </v-chip>
                            <v-chip @click="dTable.search = item.text" v-for="item in dCondicions" :key="item.value" class="ma-1" color="primary" text-color="white">
                                <v-avatar left >{{item.value}}</v-avatar> {{item.text}}
                            </v-chip>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="dTable.search"
                            prepend-icon="search"
                            label="Filtrar por ..."
                            single-line
                            hide-details
                            dark
                            clearable
                        ></v-text-field>
                    </v-toolbar>
                    <v-data-table
                        :headers="dTable.headers"
                        :items="computedPersonals"
                        :search="dTable.search"
                        item-value="IdPersonal"
                        class="elevation-1 zebra-table"
                        :custom-filter="customFilter">
                        <template v-slot:item="{ item, headers }">
                            <tr>
                                <td v-for="header in headers" :key="header.value">
                                    <template v-if="header.value === 'expand-icon'">
                                        <v-icon @click.stop="toggleExpand(item)">
                                            {{ item.expanded ? 'expand_less' : 'expand_more' }}
                                        </v-icon>
                                    </template>
                                    <template v-if="header.value === 'Personal'">
                                            <v-avatar size="36px" v-if="!item.error">
                                                <v-img
                                                    
                                                    :src="fuFoto(item.DNI)"
                                                    @error="$set(item, 'error', true)"
                                                    size="36px"
                                                />
                                            </v-avatar>
                                            <v-avatar v-else color="primary" size="36px">
                                                <span class="white--text text-h5" v-text="item.Personal.substring(0,2)"></span>
                                            </v-avatar>
                                         <span @click="fuCopy(item.IdPersonal)" class="blue--text text-h5 ml-1" v-text="item.Personal" :title="item.IdPersonal+item.Usuario"></span>
                                    </template>
                                    <template v-else-if="header.value === 'pricargo.Descripcion'">
                                        {{ item.pricargo.Descripcion }}
                                    </template>
                                    <template v-else-if="header.value === 'Condicion'">
                                        {{ item.Condicion }}
                                    </template>
                                    <template v-else-if="header.value === 'actions'">
                                        <v-menu bottom left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-title><v-btn @click.stop="fuCVModalOpen(item.DNI)" color="primary" block><v-icon>person</v-icon> CV</v-btn></v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>
                                    <template v-else>
                                        {{ item[header.value] }}
                                    </template>
                                </td>
                            </tr>
                            <tr v-if="item.expanded">
                                <td :colspan="headers.length">
                                    <div v-if="item.expanded">
                                        <v-card flat>
                                        <v-card-text>
                                            <h3 class="font-weight-bold">DETALLE</h3>
                                            <ul>
                                                <li v-for="curriculum in item.pricurriculums" :key="curriculum.NombreEmpresa">
                                                    <span class="font-weight-bold blue--text" :class="curriculum.EsValido ? 'blue--text' : 'orange--text'">{{ curriculum.NombreEmpresa }}:</span> {{ curriculum.Titulo }}
                                                </li>
                                            </ul>
                                        </v-card-text>
                                        </v-card>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="dCVModal.dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Curriculum Vitae</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dCVModal.dialog=false"><v-icon>close</v-icon></v-btn>
                </v-toolbar>
                <CurriculumByDocumentoIdentidad :pDocumentoIdentidad="dDNI" :pRol="dRol"/>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<script>
import gql from 'graphql-tag';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {fuCopy, fuFoto} from '@/helpers/index.js';
import CurriculumByDocumentoIdentidad from '@/components/PRI/CurriculumByDocumentoIdentidad'

export default {
    name: 'PersonaCV',
    mounted(){
        this.fuLoad();
        this.dRol = this.$route.params.pRol;
    },
    components: {
        CurriculumByDocumentoIdentidad
    },
    data: () => ({
        dDNI: null,
        dPersonals: [],
        dRol: null,
        dCondicions: null,
        dTable: {
            headers: [
                // { value: 'IdPersonal', text: 'IdPersonal', align: 'd-none'},
                { value: 'expand-icon', text: '', sortable: false, width: '1%'},
                { value: 'Personal', text: 'Apellidos y Nombres' },
                { value: 'pricargo.Descripcion', text: 'Cargo' },
                { value: 'Condicion', text: 'Condicion', align: 'center' },
                { value: 'actions', text: '...', sortable: false, width: '1%'},
            ],
            loading: false,
            search: null,
        },
        dCVModal: {
            dialog: false,
            IsUpdating: false,
        },
    }),
    computed: {
        computedPersonals() {
            if (!this.dPersonals) return [];

            return this.dPersonals.map(person => {
                const empresasFlat = person.pricurriculums.map(c => c.NombreEmpresa).join(', ');
                return { ...person, empresasFlat };
            });
        }
    },
    methods: {
        fuCopy, fuFoto,
        async fuLoad() {
            this.dLoading = true;
            try {
                let response = null;
                
                if (typeof this.$route.params.pCargo == "undefined"){
                    response = await this.$apollo.query({
                        query: gql`
                            query consulta{
                                pripersonalActivo{
                                    IdPersonal
                                    Personal
                                    DNI
                                    Condicion
                                    Usuario
                                    pricargo{
                                        Descripcion
                                    }
                                    pricurriculums{
                                        NombreEmpresa
                                        Titulo
                                        EsValido
                                    }
                                }
                            }
                        `,
                        fetchPolicy: 'no-cache',
                    })
                } else {
                    response = await this.$apollo.query({
                        query: gql`
                            query consulta($IdCargo: Int!){
                                pripersonalActivo: pripersonalActivoByIdCargo(IdCargo:$IdCargo){
                                    IdPersonal
                                    Personal
                                    DNI
                                    Condicion
                                    pricargo{
                                        Descripcion
                                    }
                                    pricurriculums{
                                        NombreEmpresa
                                        Titulo
                                        EsValido
                                    }
                                }
                            }
                        `,
                        fetchPolicy: 'no-cache',
                        variables: {
                            IdCargo: this.$route.params.pCargo,
                        }
                    })
                }
                const condicionMap = {'P': 'Personal de Planta', 'C': 'Horas Completa', 'H': 'Horas Parcial'};                

                this.dPersonals = response.data.pripersonalActivo.map((p, i) => {
                    const condicionTexto = condicionMap[p.Condicion.toUpperCase()] || p.Condicion;
                    return {
                        ...p,
                        Condicion: condicionTexto,
                        error: false,
                        index: i,
                        expanded: false,
                    }
                });

                this.dPersonals.sort((a, b) => {
                    const personalA = a.Personal.toUpperCase();
                    const personalB = b.Personal.toUpperCase();
                    
                    if (personalA < personalB) {
                        return -1; // 'a' viene antes que 'b'
                    }
                    if (personalA > personalB) {
                        return 1;  // 'b' viene antes que 'a'
                    }
                    return 0;      // Son iguales
                });

                const conteoObjeto = this.dPersonals.reduce((acc, personal) => {
                    const codigo = personal.Condicion.toUpperCase(); 
                    acc[codigo] = (acc[codigo] || 0) + 1;
                    return acc;
                }, {});

                this.dCondicions = Object.entries(conteoObjeto).map(([codigo, cantidad]) => ({
                    value: String(cantidad),
                    text: condicionMap[codigo] || codigo
                }));
                
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        fuCVModalOpen(pDNI){
            this.dCVModal.dialog = true;
            this.dDNI = pDNI;
        },
        toggleExpand(item) {
            this.$set(item, 'expanded', !item.expanded);
        },
        customFilter(value, search, item) {
            search = search.toLowerCase();
            if (item.Personal && item.Personal.toLowerCase().includes(search)) return true;
            if (item.Condicion && item.Condicion.toLowerCase().includes(search)) return true;
            if (item.pricargo && item.pricargo.Descripcion && item.pricargo.Descripcion.toLowerCase().includes(search)) return true;
            if (item.pricurriculums && item.pricurriculums.length > 0) {
                return item.pricurriculums.some(curr => 
                    curr.NombreEmpresa.toLowerCase().includes(search) ||
                    (curr.Titulo && curr.Titulo.toLowerCase().includes(search))
                );
            }
            return false;
        },
    }
}
</script>
<style scoped>
    .portrait {
        margin: 0 auto;
        max-width: 1000px;
        width: 100%;
    }    
    .zebra-table >>> tbody tr:nth-child(odd) {
        background-color: #E3F2FD;
    }
    .zebra-table >>> tbody tr:nth-child(even) {
        background-color: #ffffff;
    }

</style>
